import clsx from "clsx"
import styles from "./Badge.module.css"

export type BadgeSize = "Small" | "Medium" | "Large"
export type BadgeColor =
  | "Grey"
  | "Blue"
  | "Purple"
  | "Red"
  | "Pink"
  | "Green"
  | "Teal"
  | "Amber"

export type BadgeProps = {
  className?: string
  label?: string
  size?: BadgeSize
  color?: BadgeColor
  filled?: boolean
}

export function Badge({
  className,
  label = "Label",
  size = "Small",
  color = "Grey",
  filled = true,
}: BadgeProps) {
  return (
    <span
      className={clsx(
        styles.badge,
        styles[size],
        styles[color],
        filled ? styles.filled : styles.outline,
        className,
      )}
    >
      <span className={styles.label}>{label}</span>
    </span>
  )
}
